import { FC } from 'react';
import { clsx } from 'clsx';
import { Section, Box, Image } from '@alto-avios/alto-ui';

import { HelpCentre } from '../HelpCentre';
import { Loader } from '../Loader';
import { HeaderData } from '../services/content';

import styles from './DesktopBannerContent.module.scss';

export interface DesktopBannerContentProps {
  programmeLabel: string;
  programmeLogo?: HeaderData['programmeLogo'];
  isLoading?: boolean;
}

export const DesktopBannerContent: FC<DesktopBannerContentProps> = ({ isLoading = false, programmeLabel, programmeLogo }) => (
  <div data-testid="desktop-banner" className={styles.fullWidth}>
    <Box width="100%" backgroundColor="layer1" justifyContent="center" borderWidth="none">
      <Section className={clsx(styles.bannerSection, styles.displayOnDesktop)} paddingX="xs" paddingY={null}>
        <Section.Container>
          <Box justifyContent="spaceBetween" alignItems="center" width="100%" height="48px" borderWidth="none">
            <div className={styles.bannerLeft}>
              {isLoading ? (
                <Loader height={36} width={240} />
              ) : (
                <>
                  {/* TODO: Replace with alto-ui `Label` component when available */}
                  <span>{programmeLabel}</span>
                  {programmeLogo && <Image src={programmeLogo.image} alt={programmeLogo.alt} />}
                </>
              )}
            </div>
            <div className={styles.bannerLink}>{isLoading ? <Loader height={36} width={140} /> : <HelpCentre />}</div>
          </Box>
        </Section.Container>
      </Section>
    </Box>
  </div>
);
